import { TableColumn } from 'react-data-table-component';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { PaymentStatusSummary } from '../../../../app/models/PaymentStatusSummary';
import { formatAmount, formatMoney } from '../../../../utils/utils';
import { useState } from 'react';

interface Props {
    summaries: PaymentStatusSummary[];
    loading?: boolean;
    paymentStatusCurrency?: string;
}

const PaymentStatusSummaryTable = ({
    summaries,
    loading = false,
    paymentStatusCurrency
}: Props) => {
    
    // Filtro dummy para cumplir con la interfaz de DefaultDataTable
    const [dummyFilter, setDummyFilter] = useState({});
    
    const columns: TableColumn<PaymentStatusSummary>[] = [
        {
            name: 'Servicio',
            width: '150px',
            selector: (row) => row.service_name ?? '',
            cell: (row) => <span className="">{row.service_name ?? '-'}</span>
        },
        {
            name: 'Producto',
            width: '150px',
            selector: (row) => row.product_name ?? '',
            cell: (row) => <span className="">{row.product_name ?? '-'}</span>
        },
        {
            name: 'Descripción',
            selector: (row) => row.description ?? '',
            cell: (row) => <span className="">{row.description ?? '-'}</span>
        },
        {
            name: 'Cantidad Total',
            width: '130px',
            selector: (row) => row.total_quantity ?? 0,
            cell: (row) => (
                <span className="">
                    {row.total_quantity 
                        ? `${formatAmount(Number(row.total_quantity))} ${row?.unit_quantity_name ?? ''}` 
                        : '-'
                    }
                </span>
            )
        },
        {
            name: 'Tarifa de Venta',
            width: '160px',
            selector: (row) => row.rate ?? 0,
            cell: (row) => {
                if (!row.rate) return <span className="">-</span>;
                const currency = paymentStatusCurrency || row?.currency_rate_name || 'CLP';
                const unit = row?.rate_unit_name ?? '';
                const rateValue = Number(row.rate).toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                return (
                    <span className="">
                        {rateValue} {currency}{unit ? `/${unit}` : ''}
                    </span>
                );
            }
        },
        {
            name: 'Monto Total',
            width: '150px',
            selector: (row) => row.total_amount ?? 0,
            cell: (row) => {
                if (!row.total_amount) return <span className="font-weight-bold">-</span>;
                const currency = paymentStatusCurrency || row?.currency_rate_name || 'CLP';
                return (
                    <span className="font-weight-bold">
                        {currency} {formatMoney(row.total_amount, currency)}
                    </span>
                );
            }
        }
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={summaries}
            progressPending={loading}
            pagination={false}
            paginationTotalRows={summaries.length}
            filter={dummyFilter}
            setFilter={setDummyFilter}
        />
    );
};

export default PaymentStatusSummaryTable;
